import { render, staticRenderFns } from "./manage-economic-programming.vue?vue&type=template&id=51ea199a&scoped=true"
import script from "./manage-economic-programming.vue?vue&type=script&lang=js"
export * from "./manage-economic-programming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea199a",
  null
  
)

export default component.exports